var gql = require("@apollo/client").gql;

const PROVIDERS_V2_INFO = gql`
	query Providers_Info($regionUrl: String!) {
		providersInfo(regionUrl: $regionUrl) {
			min_minutes
			max_minutes
			min_gigabytes
			max_gigabytes
			min_price
			max_price
		}
	}
`;

export default PROVIDERS_V2_INFO;
